// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"Loader_lds-ellipsis__conBw","lds-ellipsis1":"Loader_lds-ellipsis1__LBpzv","lds-ellipsis2":"Loader_lds-ellipsis2__wlS5F","lds-ellipsis3":"Loader_lds-ellipsis3__iSFIy"};